import Rules from './init-rules';
import Services from './init-services';
import Lookups from './init-lookups';
import Editors from './init-editors';
import SearchGroups from './init-search-groups';
import DefaultFields from './default/fields.json';
const Fields = [];





const SearchActions = [];
const VoucherActions = [];



const appConfig = {
    Fields: Fields,
    DefaultFields: DefaultFields,
    Rules: Rules,
    Services: Services,
    Lookups: Lookups,
    Editors: Editors,
    SearchGroups: SearchGroups,
    SearchActions: SearchActions,
    VoucherActions: VoucherActions
};

export default appConfig;
